var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showImageStatus)?_c('img',{staticClass:"icon-err",attrs:{"src":require('@/assets/images/' + _vm.image)}}):_vm._e(),_c('p',{staticClass:"p-err"},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }